import { IFeature, IndustryType, RegionType, StaticFileTypeEnum } from './model/common';
import { defHttp } from '/@/utils/http/axios';

export enum CommonApi {
  // 全量获取地区字典
  areaDict = '/analysis/data-dict/regions',
  // 全量获取行业字典
  industryDict = '/analysis/data-dict/industries',
  // 获取静态文件
  staticFile = '/member/docs/search',
  // 获取特性开关（灰度功能配置）
  features = '/analysis/gray/get-config',
}
/**
 * 接口 [全量获取地区字典](https://exmt-dev1.microconnect.cc/analysis/doc.html#/-analysis-v3-api-docs/%E6%95%B0%E6%8D%AE%E5%AD%97%E5%85%B8%E7%9B%B8%E5%85%B3%E6%8E%A5%E5%8F%A3/getDataRegions)
 * @returns
 * */
export function getAreaDict() {
  return defHttp.get<RegionType[]>({ url: CommonApi.areaDict });
}
/**
 * 接口 [全量获取行业字典](https://exmt-dev1.microconnect.cc/analysis/doc.html#/-analysis-v3-api-docs/%E6%95%B0%E6%8D%AE%E5%AD%97%E5%85%B8%E7%9B%B8%E5%85%B3%E6%8E%A5%E5%8F%A3/getDataIndustries)
 */
export function getIndustryDict() {
  return defHttp.get<IndustryType[]>({ url: CommonApi.industryDict });
}

/**
 * 接口 [获取静态文件](https://exmt-dev1-api.microconnect.cc/member/doc.html#/-member-v3-api-docs/%E9%9D%99%E6%80%81%E6%96%87%E4%BB%B6/searchDocs)
 */
export function getStaticFile(type: StaticFileTypeEnum) {
  return defHttp.get<{ path: string }[]>({ url: CommonApi.staticFile, params: { type } });
}

/**
 * 接口 [获取特性开关（灰度功能配置）](https://exmt-dev1.microconnect.cc/analysis/doc.html#/-analysis-v3-api-docs/%E7%89%B9%E6%80%A7%E5%BC%80%E5%85%B3/getConfig)
 */
export function fetchFeaturesApi() {
  return defHttp.get<IFeature[]>({ url: CommonApi.features });
}
